import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import currencyToWords from '../utils/CurrencyToWords';

const Invoice = () => {
    const params = useParams();

    const selectedBank = useSelector(state => state?.user?.bank);


    //for quotation purposes
    const location = useLocation();
    console.log({ location });

    document.title = "V INTERIOR MALL";

    const id = params.id;

    const { user } = useSelector(state => state.user);

    const [company, setCompany] = useState("V TRADERS");
    const [title, setTitle] = useState("V INTERIOR MALL")

    const [amountString, setAmountString] = useState("");

    const [sold, setSold] = useState();


    const getQuotationById = async (id) => {
        try {
            let response = await axios.get(`/quotation/${id}`);
            if (response.data.success) {
                setSold(response.data.quotation);
            }
        } catch (error) {
            toast.error(error.response.data.message);
        }
    }

    useEffect(() => {
        // if state is present then don't need to fetch from the database
        if (location.state) {
            //inject data for getting quotation information
            getQuotationById(location.state);
        }
        else {
            (async () => {
                try {
                    const response = await axios.get(`sell/${id}`);
                    if (response.data.success) {
                        setSold(response.data.selling);
                    }
                } catch (error) {
                    toast.error(error.response.data.message);
                }

            })();

        }

    }, [])

    useEffect(() => {
        if (company === "") {
            setCompany("V TRADERS");
        }
        if (title === "") {
            setTitle("V INTERIOR MALL");
        }
    }, [company, title])

    useEffect(() => {
        if (sold?.totalAmount) {
            let totalAmount = currencyToWords?.convert(Number(sold?.totalAmount), { currency: true });
            setAmountString(totalAmount);
        }
    }, [sold])


    return (
        <>
            <div className="flex justify-center items-center my-4 gap-2">
                {location.state && <p className='text-red-600 font-bold bg-red-200 p-2 rounded-lg print:hidden'>This is just a quotation</p>}
                <button onClick={() => window.print()} className="btn btn-outline print:hidden">Download/Print Invoice</button>
            </div>

            <div className='text-center print:hidden flex gap-2 justify-center'>
                <input
                    onChange={(e) => setCompany(e.target.value)}
                    type="text"
                    placeholder="Enter Company name here..."
                    className="input input-bordered input-info w-full max-w-xs" />
                <input
                    onChange={(e) => setTitle(e.target.value)}
                    type="text"
                    placeholder="Enter title here..."
                    className="input input-bordered input-info w-full max-w-xs" />
            </div>


            <div className="my-2 border-2 border-black px-2 py-2 space-y-2">
                <h1 className='text-center text-xl font-bold'>{title?.toUpperCase()}</h1>

                <h2 className='text-md font-bold uppercase ml-2'>{company}</h2>
                <div className='flex justify-center items-center'>
                    <div className='text-center flex  text-sm'>
                        <div className=' text-start p-2 border border-black border-r-0'>
                            <h2><span className='font-bold'>Email:</span> info@vfurno.com, info@vinteriormall.in</h2>
                            <h2><span className='font-bold'>GSTIN:</span> 29CFKPM2771M1ZQ</h2>
                            <h2><span className='font-bold'>Website:</span> https://vinteriormall.in/</h2>
                            <h2><span className='font-bold'>Address:</span>
                                1/891/71/1A/29, Near chittari adda, opposite Bhavani temple, New jewargi road Uday nagar kalaburgi-585104</h2>
                            <h2><span className='font-bold'>Contact:</span> +918867562938,
                                +917795202495</h2>
                        </div>

                        <hr />
                        <div className=' text-left border border-black p-2'>
                            <div className='border-b border-black '><span className="font-bold ">Invoice No:</span> {sold?.invoiceNumber}</div>
                            <div className='border-black border-b'><span className="font-bold">Customer:</span> {sold?.customer?.name}</div>
                            <div className='border-black border-b'><span className="font-bold">Contact:</span> {sold?.customer?.phoneNo}</div>
                            <div className='border-black border-b'><span className="font-bold">Address:</span> {sold?.customer?.address}</div>
                            <hr />
                            <div><span className="font-bold">Order Date: </span>{new Date(sold?.date)?.toLocaleDateString("en-GB")}</div>
                        </div>

                    </div>
                </div>

                <hr />
                <div className="font-bold text-sm ">Order ID:  {sold?._id}</div>
                {/* <div><span className='font-bold'>Category: </span>{sold?.category?.title}</div> */}
                <table className="table">

                    <tr className="text-center">
                        <th className='border border-black p-1'>Category</th>
                        <th className='border border-black p-1'>Product</th>
                        <th className='border border-black p-1'>Material Code</th>
                        <th className='border border-black p-1'>MRP</th>
                        <th className='border border-black p-1'>Quantity</th>
                        <th className='border border-black p-1'>Price</th>
                        <th className='border border-black p-1'>GST</th>
                        <th className='border border-black p-1'>Discount</th>
                        <th className='border border-black p-1'>Total</th>
                    </tr>
                    {sold?.products?.map((p) => {
                        return (
                            <>
                                <tr className='text-center'>
                                    <td className='p-1 border border-black'>{sold?.category?.title || p?.category?.title}</td>
                                    <td className='p-1 border border-black'>{p?.product?.name}</td>
                                    <td className='p-1 border border-black'>{p?.product?.materialCode}</td>
                                    <td className='p-1 border border-black'>{p?.product?.MRP}</td>
                                    <td className='p-1 border border-black'>{p?.quantity}</td>
                                    <td className='p-1 border border-black'>{p?.price}</td>
                                    <td className='p-1 border border-black'>{p?.sellingGst}%</td>
                                    <td className='p-1 border border-black'>{p?.discount}%</td>
                                    <td className='p-1 border border-black'>₹{Number(p?.total)?.toLocaleString('en-IN')}</td>
                                </tr>
                            </>
                        )
                    })}
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className='font-bold bg-gray-300 border border-black'>Total</td>
                        <td className='font-bold bg-gray-300 border border-black'>₹{Number(sold?.totalAmount)?.toLocaleString('en-IN')}</td>
                    </tr>

                </table>
                <hr />
                <div className=' pt-4' >
                    <div>
                        <div className="font-bold">Payment Method: {sold?.paymentMethod}</div>
                        <div className="font-bold">Total: ₹{Number(sold?.totalAmount)?.toLocaleString("en-IN")}</div>
                        <div className='font-bold mb-3'>Total Amount (in Words): <span className='text-xl font-bold'>{amountString}</span></div>
                        <div className='font-bold border border-black mr-1 mb-2 p-2'>
                            Declaration  <br /> <hr />
                            1. Goods once sold will not be taken back or exchanged.<br />
                            2. GST applicable as per the existing laws. <br />
                            3. Certified that the particulars are true and correct.
                        </div>
                        <div className="flex justify-between">
                            <div className='font-bold border border-black mr-1 p-2'>
                                Company's Bank Details <br /> <hr />
                                Bank Name: <span className='text-xl'>{selectedBank?.bankName}</span> <br />
                                A/C No: <span className='text-xl'>{selectedBank?.accountNumber}</span> <br />
                                Branch & IFSC Code: <span className='text-xl'>{selectedBank?.branch} & {selectedBank?.IFSC}</span>
                            </div>
                            <div className=' items-center'>
                                <h1 className='font-bold'>Authorized Signature:</h1>
                                <div className='border-2 border-black font-bold w-[260px] h-[100px]'></div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default Invoice;